export const environment = {
  production: false,
  environment: 'uat',
  configUrl: 'https://uat.property-tax-fraud-tracker.oab-aws.com/config',
  apiUrl: 'https://api-uat.property-tax-fraud-tracker.oab-aws.com',
  websocketUrl: 'wss://websocket-uat.property-tax-fraud-tracker.oab-aws.com',
};
